import { useQuery } from '@tanstack/react-query';
import { getAuditsByDate } from 'services/auditService';
import AuditsByDateModel from 'models/audit/AuditsByDateModel';

export function useAuditsByDate(storeId: string | null | undefined, date: string | null | undefined) {
  return useQuery<AuditsByDateModel | null, Error>({
    queryKey: ['audits-by-date', storeId, date],
    queryFn: () => getAuditsByDate(storeId!, date!),
    enabled: !!storeId && !!date,
    retry: false // Don't retry on error to show the error state immediately
  });
}

